<template>
    <slot></slot>

    <div class="flex items-center justify-center w-full">
        <div class="w-full max-w-[600px]">
            <p class="mb-4 text-center">
                {{ $t('inventory.product.import_form.content.file.select') }}
            </p>

            <label
                for="file"
                class="cursor-pointer text-xs text-gray-400 block mb-8 hover:text-gray-600 text-left"
                ><i class="fa-regular fa-paperclip mr-1 text-sm"></i>{{ label }}
            </label>
            <input
                id="file"
                accept=".csv"
                class="hidden"
                href="#"
                type="file"
                @change="$emit('fileChanged', $event)"
            />
        </div>
    </div>
    <div :class="$theme('modal.footer.container')">
        <div :class="$theme('modal.footer.button_container')">
            <LoadingButton
                :extra-class-name="$theme('modal.footer.button')"
                :class-name="$theme('button.style.cancel')"
                prevent-default
                @click="$emit('previous')"
                >{{ $t('misc.back') }}</LoadingButton
            >
            <LoadingButton
                :loading="loading"
                :extra-class-name="$theme('modal.footer.button')"
                :class="!file ? 'cursor-not-allowed' : 'cursor-pointer'"
                :disabled="!file"
                @clicked="$emit('validate')"
                >{{ $t('actions.validate') }}</LoadingButton
            >
        </div>
    </div>
</template>
<script lang="ts" setup>
    defineProps<{
        file: File | undefined;
        label: string;
        loading: boolean;
    }>();
    defineEmits<{
        (e: 'previous'): void;
        (e: 'validate'): void;
        (e: 'fileChanged', $event: Event): void;
    }>();
</script>
